import AccessorAccessor from "./Accessor/Accessor";
import AnimationAnimation from "./Animation/Animation";
import AnimationInterpolators from "./Animation/Interpolators";
import ComponentsGLTFAnimationComponent from "./Components/GLTFAnimationComponent";
import ComponentsGLTFJointComponent from "./Components/GLTFJointComponent";
import ComponentsGLTFModelComponent from "./Components/GLTFModelComponent";
import ParserConstantConverter from "./Parser/ConstantConverter";
import ParserGLTFMaterialFactory from "./Parser/GLTFMaterialFactory";
import ParserMaterialParser from "./Parser/MaterialParser";
import ParserParser from "./Parser/Parser";
import UtilResourceResolver from "./Util/ResourceResolver";
var __VERSION__ = "1.8.1";
var __NAME__ = "grimoirejs-gltf";
import __MAIN__ from "./main";
var __EXPOSE__ = {
    "Accessor": {
        "Accessor": AccessorAccessor
    },
    "Animation": {
        "Animation": AnimationAnimation,
        "Interpolators": AnimationInterpolators
    },
    "Components": {
        "GLTFAnimationComponent": ComponentsGLTFAnimationComponent,
        "GLTFJointComponent": ComponentsGLTFJointComponent,
        "GLTFModelComponent": ComponentsGLTFModelComponent
    },
    "Parser": {
        "ConstantConverter": ParserConstantConverter,
        "GLTFMaterialFactory": ParserGLTFMaterialFactory,
        "MaterialParser": ParserMaterialParser,
        "Parser": ParserParser
    },
    "Util": {
        "ResourceResolver": UtilResourceResolver
    }
};
let __BASE__ = __MAIN__();
Object.assign(__EXPOSE__, {
    __VERSION__: __VERSION__,
    __NAME__: __NAME__
});
Object.assign(__BASE__ || {}, __EXPOSE__);
window["GrimoireJS"].lib.gltf = __EXPOSE__;
export default __BASE__;



// WEBPACK FOOTER //
// ./src/index.ts